import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-important-links',
  templateUrl: './important-links.component.html',
  styleUrls: ['./important-links.component.scss']
})
export class ImportantLinksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    var modal: HTMLElement = document.getElementById("myModal") as HTMLElement;
    var btn: HTMLElement = document.getElementById("myBtn") as HTMLElement;
    var span = document.getElementsByClassName("close")[0];
    btn.onclick = function () {
      modal.style.display = "block";
    }
  
  var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.nopaperforms.com/emwgts.js"; document.body.appendChild(s);
}

}